import React from 'react';
import { CtaButton } from '../CtaButton';
import { ProductImage } from '../ProductImage';
import { BRAND, PRODUCT_NAME, heroBadges } from '../../data/salesContent';
export function HeroSection() {
  return <header className="bg-slate-950 px-5 pb-12 pt-8 text-center md:px-12 md:pb-14 md:pt-10" data-id="element-110" data-mp="219l2zb9wmci5">
      <p className="font-display text-xs font-bold uppercase tracking-[0.3em] text-cyan-400 md:text-sm" data-id="element-111" data-mp="1x9ann80829qm">{BRAND}</p>
      <h1 className="mx-auto mt-4 max-w-2xl font-display text-[1.75rem] font-extrabold uppercase leading-[1.1] text-white md:text-[2.5rem]" data-id="element-112" data-mp="1sapu1rfh6ob5">
        El sistema completo para entender, cuidar y mantener tu auto
      </h1>
      <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-zinc-300 md:text-[17px]" data-id="element-113" data-mp="1ikecv36s6imb">
        Dejá de adivinar: todo lo que necesitás para entender y mantener tu auto, en un solo sistema práctico.
      </p>
      <ProductImage className="mx-auto mt-6 w-[90%] max-w-[28.8rem]" data-id="element-114" data-mp="19l9epxz4srao" />
      <div className="mt-6" data-id="element-115" data-mp="14leta9y4ktx0">
        <CtaButton data-id="element-116" data-mp="14mg2e8vkz6c3">Quiero acceder al sistema completo</CtaButton>
      </div>

      <p className="mt-6 font-display text-xl font-extrabold uppercase text-white md:text-2xl" data-id="element-117" data-mp="31mku5cr9bssw">{PRODUCT_NAME}</p>
      <ul className="mt-4 flex flex-wrap justify-center gap-2" data-id="element-118" data-mp="36gxia03ohsaz">
        {heroBadges.map(({
        label,
        icon: Icon
      }) => <li key={label} className="flex items-center gap-2 rounded-full border border-zinc-700 bg-zinc-900 px-3.5 py-1.5 text-sm font-semibold text-zinc-100" data-id="element-119" data-mp="2wors8vwzlkyf">
            <Icon className="h-4 w-4 text-cyan-400" aria-hidden="true" data-id="element-120" data-mp="3kff05h6wkakz" />
            {label}
          </li>)}
      </ul>
    </header>;
}